"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi.js"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'decorationManage',
  data: function data() {
    return _objectSpread(_objectSpread({
      dialogVisible: false
    }, (0, _paginationEffect.default)(this.getList)), {}, {
      appId: null,
      appCustomerName: '',
      tableData: {
        list: [],
        total: 0
      }
    });
  },
  methods: {
    open: function open(row) {
      var appRow = row && _typeof(row) === 'object' ? row : {
        id: row
      };
      this.appId = appRow.id;
      this.appCustomerName = appRow.customerName || '';
      this.dialogVisible = true;
      this.getList();
    },
    close: function close() {
      this.dialogVisible = false;
    },
    /**
     * request 网络请求工具
     */
    request: function () {
      var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(api, params, callback) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return api(params);
            case 1:
              res = _context.v;
              callback(res);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message({
                type: 'error',
                message: '出错了！'
              });
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function request(_x, _x2, _x3) {
        return _request.apply(this, arguments);
      }
      return request;
    }(),
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        var params;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = _objectSpread({
                appId: this.appId
              }, this.pageData);
              this.request(companyappApi.companyDesignListApi, params, function (res) {
                _this.tableData = res;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    add: function add() {
      this.$router.push({
        path: "/applet/skinSetting",
        query: {
          miniAppId: this.appId,
          type: 2
        }
      });
    },
    addVisitor: function addVisitor() {
      this.$router.push({
        path: "/applet/skinSetting",
        query: {
          miniAppId: this.appId,
          type: 5
        }
      });
    },
    go: function go(row) {
      this.$router.push({
        path: "/applet/skinSetting",
        query: {
          miniAppId: this.appId,
          type: row.type,
          id: row.id
        }
      });
    },
    setHomePage: function setHomePage(row) {
      var _this2 = this;
      var params = {
        appId: this.appId,
        id: row.id
      };
      this.request(companyappApi.setHomepageApi, params, function () {
        _this2.$message.success('操作成功！');
        _this2.getList();
        _this2.$emit('refresh');
      });
    },
    setVisitorHomePage: function setVisitorHomePage(row) {
      var _this3 = this;
      var params = {
        appId: this.appId,
        id: row.id
      };
      this.request(companyappApi.setVisitorHomepageApi, params, function () {
        _this3.$message.success('操作成功！');
        _this3.getList();
        _this3.$emit('refresh');
      });
    },
    deleteRecord: function () {
      var _deleteRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _this4 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.$alert('确认删除？', '删除', {
                confirmButtonText: '删除',
                callback: function callback(action) {
                  if (action === 'confirm') {
                    _this4.request(companyappApi.deleteApi, {
                      id: row.id
                    }, function () {
                      _this4.$message.success('删除成功');
                      _this4.getList();
                    });
                  }
                }
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function deleteRecord(_x4) {
        return _deleteRecord.apply(this, arguments);
      }
      return deleteRecord;
    }(),
    deleteSharing: function () {
      var _deleteSharing = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row) {
        var _this5 = this;
        var params;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                appId: this.appId,
                id: row.id
              };
              this.request(companyappApi.removeRelateApi, params, function () {
                _this5.$message.success('移除共享成功');
                _this5.getList();
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function deleteSharing(_x5) {
        return _deleteSharing.apply(this, arguments);
      }
      return deleteSharing;
    }(),
    disabledRecord: function () {
      var _disabledRecord = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _this6 = this;
        var params;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                id: row.id
              };
              this.request(companyappApi.disableApi, params, function () {
                _this6.$message.success('操作成功！');
                _this6.getList();
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function disabledRecord(_x6) {
        return _disabledRecord.apply(this, arguments);
      }
      return disabledRecord;
    }(),
    enable: function () {
      var _enable = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _this7 = this;
        var params;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              params = {
                id: row.id
              };
              this.request(companyappApi.enableApi, params, function () {
                _this7.$message.success('操作成功！');
                _this7.getList();
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function enable(_x7) {
        return _enable.apply(this, arguments);
      }
      return enable;
    }()
  }
};